export const CE_MAKE_MULTIPART = "CE_MAKE_MULTIPART";
export const ceMakeMultipart = (clientContentID) => ({
  type: CE_MAKE_MULTIPART,
  client_content_id: clientContentID,
});
